// Theme: mechanical-botanical
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'mechanical-botanical',
  name: 'MECHANICAL BOTANICAL',
  tagline: 'MECHANICAL BOTANICAL',
  description: 'Epico verde equilibrando linguagem mecanica e organica.',
  category: 'system-core',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1A2420', '#243530', '#4ADE80', '#E8F5EE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-mechanical-botanical'
  },
  colorVars: {
    '--accent': '#4ADE80',
    '--accent-foreground': '#1A2420',
    '--background': '#1A2420',
    '--border': '#4A7A5A',
    '--card': '#243530',
    '--card-border-active': 'rgba(74, 222, 128, 0.55)',
    '--card-completed': '#1E2E29',
    '--card-foreground': '#E8F5EE',
    '--card-glow': 'rgba(74, 222, 128, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#E8F5EE',
    '--hold-fill': '#4ADE80',
    '--input': '#4A7A5A',
    '--modal-bg': '#1A2420',
    '--modal-border': '#4A7A5A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#4A7A5A',
    '--muted-foreground': '#E8F5EE',
    '--nav-active': '#4ADE80',
    '--nav-bg': '#243530',
    '--popover': '#243530',
    '--popover-foreground': '#E8F5EE',
    '--primary': '#4ADE80',
    '--primary-foreground': '#1A2420',
    '--ring': '#4ADE80',
    '--secondary': '#4A7A5A',
    '--secondary-foreground': '#E8F5EE',
    '--streak': '#4ADE80',
    '--success': '#22c55e',
    '--success-foreground': '#1A2420',
    '--xp': '#4ADE80',
    '--xp-bg': '#243530'
  },
  resolvedVars: {
    '--accent': '#4ADE80',
    '--accent-foreground': '#1A2420',
    '--accent-foreground-hsl': '156 16% 12%',
    '--accent-foreground-oklch': 'from #1A2420 l c h',
    '--accent-hsl': '142 69% 58%',
    '--accent-oklch': 'from #4ADE80 l c h',
    '--background': '#1A2420',
    '--background-hsl': '156 16% 12%',
    '--background-oklch': 'from #1A2420 l c h',
    '--border': '#4A7A5A',
    '--border-hsl': '140 24% 38%',
    '--border-oklch': 'from #4A7A5A l c h',
    '--border-w': '1px',
    '--card': '#243530',
    '--card-border-active': 'rgba(74, 222, 128, 0.55)',
    '--card-completed': '#1E2E29',
    '--card-completed-hsl': '161 21% 15%',
    '--card-completed-oklch': 'from #1E2E29 l c h',
    '--card-foreground': '#E8F5EE',
    '--card-foreground-hsl': '148 39% 94%',
    '--card-foreground-oklch': 'from #E8F5EE l c h',
    '--card-glow': 'rgba(74, 222, 128, 0.10)',
    '--card-hsl': '162 19% 17%',
    '--card-oklch': 'from #243530 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E8F5EE',
    '--foreground-hsl': '148 39% 94%',
    '--foreground-oklch': 'from #E8F5EE l c h',
    '--hold-fill': '#4ADE80',
    '--hold-fill-hsl': '142 69% 58%',
    '--hold-fill-oklch': 'from #4ADE80 l c h',
    '--input': '#4A7A5A',
    '--input-hsl': '140 24% 38%',
    '--input-oklch': 'from #4A7A5A l c h',
    '--modal-bg': '#1A2420',
    '--modal-bg-hsl': '156 16% 12%',
    '--modal-bg-oklch': 'from #1A2420 l c h',
    '--modal-border': '#4A7A5A',
    '--modal-border-hsl': '140 24% 38%',
    '--modal-border-oklch': 'from #4A7A5A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--muted': '#4A7A5A',
    '--muted-foreground': '#E8F5EE',
    '--muted-foreground-hsl': '148 39% 94%',
    '--muted-foreground-oklch': 'from #E8F5EE l c h',
    '--muted-hsl': '140 24% 38%',
    '--muted-oklch': 'from #4A7A5A l c h',
    '--nav-active': '#4ADE80',
    '--nav-active-hsl': '142 69% 58%',
    '--nav-active-oklch': 'from #4ADE80 l c h',
    '--nav-bg': '#243530',
    '--nav-bg-hsl': '162 19% 17%',
    '--nav-bg-oklch': 'from #243530 l c h',
    '--popover': '#243530',
    '--popover-foreground': '#E8F5EE',
    '--popover-foreground-hsl': '148 39% 94%',
    '--popover-foreground-oklch': 'from #E8F5EE l c h',
    '--popover-hsl': '162 19% 17%',
    '--popover-oklch': 'from #243530 l c h',
    '--primary': '#4ADE80',
    '--primary-foreground': '#1A2420',
    '--primary-foreground-hsl': '156 16% 12%',
    '--primary-foreground-oklch': 'from #1A2420 l c h',
    '--primary-hsl': '142 69% 58%',
    '--primary-oklch': 'from #4ADE80 l c h',
    '--radius': '12px',
    '--ring': '#4ADE80',
    '--ring-hsl': '142 69% 58%',
    '--ring-oklch': 'from #4ADE80 l c h',
    '--secondary': '#4A7A5A',
    '--secondary-foreground': '#E8F5EE',
    '--secondary-foreground-hsl': '148 39% 94%',
    '--secondary-foreground-oklch': 'from #E8F5EE l c h',
    '--secondary-hsl': '140 24% 38%',
    '--secondary-oklch': 'from #4A7A5A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#4ADE80',
    '--streak-hsl': '142 69% 58%',
    '--streak-oklch': 'from #4ADE80 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A2420',
    '--success-foreground-hsl': '156 16% 12%',
    '--success-foreground-oklch': 'from #1A2420 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(142 69% 58% / 0.15)',
    '--xp': '#4ADE80',
    '--xp-bg': '#243530',
    '--xp-bg-hsl': '162 19% 17%',
    '--xp-bg-oklch': 'from #243530 l c h',
    '--xp-hsl': '142 69% 58%',
    '--xp-oklch': 'from #4ADE80 l c h'
  }
}
